import { TextField } from '@mui/material';
import React from 'react';
import { Controller } from 'react-hook-form';
import ReactInputMask from 'react-input-mask';

function TextPhone({
  control,
  errors,
  dynamicField, // This should be the name you want for the field in the form
  label,
  required,
  min,
  max,
  disabled,
  type = 'text', // Default type text
  multiline,
  rows,
  minValue,
  maxValue,
  minDigits
}) {
  return (
    <div>
      <Controller
        name={dynamicField}
        control={control}
        defaultValue=""
        rules={{
          required: {
            value: required,
            message: 'This field is required',
          },
          minLength: {
            value: min,
            message: `${label} must be at least ${min} characters`,
          },
          maxLength: {
            value: max,
            message: `${label} cannot exceed ${max} characters`,
          },
          min: {
            value: minValue,
            message: `It cannot be less than ${minValue}`,
          },
          max: {
            value: maxValue,
            message: `It cannot be more than ${maxValue}`,
          },
          validate: {
            minDigits: (value) => {
              // Check for digit count
              const digitCount = (value.match(/\d/g) || []).length; // Count digits in the value
              return digitCount >= minDigits || `At least ${minDigits} digits are required`;
            },
          },
        }}
        render={({ field: { onChange, onBlur, value, ref } }) => (
          <TextField
            size="small"
            fullWidth
            label={label}
            value={value} // Bind the value from the controller
            onChange={(e) => {
              // Handle the change
              onChange(e.target.value); // Use the value from the event
            }}
            onBlur={onBlur} // Handle blur for validation
            error={Boolean(errors?.[dynamicField])} // Show error if exists
            helperText={errors?.[dynamicField] ? errors?.[dynamicField]?.message : ''}
            disabled={disabled}
            InputProps={{
              inputComponent: ReactInputMask,
              inputProps: {
                mask: '(+999) 99-999-9999',
                maskChar: '_',
              },
            }}
          />
        )}
      />
    </div>
  );
}

export default TextPhone;
